import { render, staticRenderFns } from "./ApprovalProcessModal.vue?vue&type=template&id=64862d23&scoped=true&"
import script from "./ApprovalProcessModal.vue?vue&type=script&lang=js&"
export * from "./ApprovalProcessModal.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalProcessModal.vue?vue&type=style&index=0&id=64862d23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64862d23",
  null
  
)

export default component.exports